export { ProductReviewCardDs } from './product-review-card-ds'
export type { ProductReviewCardDsProps } from './product-review-card-ds'
